import { useMemo } from 'react'
import { GetFormat, useGet } from 'sharedKernel/api'
import { PUBLIC_MEETING_ROOM_API } from '../api/constants'
import { IPublicFormSettings, normalizePublicSettingsResponse } from '../api/settingsMappers'

export const usePublicMeetingRoomSettings = (enabled = true) => {
  const settingsRequest: GetFormat = useMemo(
    () => ({
      url: PUBLIC_MEETING_ROOM_API.SETTINGS,
    }),
    []
  )

  const { data, isLoading, isFetching, isError, refetch } = useGet<unknown>(
    settingsRequest,
    'public-meeting-room-settings',
    { enabled }
  )

  const settings = useMemo(
    (): IPublicFormSettings | null => normalizePublicSettingsResponse(data),
    [data]
  )

  return {
    settings,
    isLoading,
    isRefetching: isFetching && !isLoading,
    isError,
    refetch,
  }
}
